export const LOAD_CONTENT_STARTED = 1;
export const LOAD_CONTENT_FINISHED = 2;
export const SET_STATE = 3;
export const SET_CONTENT_WRAPPER = 4;
export const ADD_BLOCK = 5;
export const REGISTER_POST_TYPE = 6;
export const REGISTER_TAXONOMY = 7;
export const REGISTER_ERROR_PAGE = 8;
export const REGISTER_NOT_FOUND_PAGE = 9;
export const REGISTER_LOADING_INDICATOR = 10;
export const LOAD_MORE_CONTENT_STARTED = 11;
export const LOAD_MORE_CONTENT_FINISHED = 12;
export const REGISTER_CUSTOMIZER_CONTROL = 13;
export const SET_HASH_SCROLL_OFFSET = 14;
export const SET_FOCUS_MODE = 15;
export const SET_WINDOW_SIZE = 16;
export const SET_WINDOW_POSITION = 17;

